module.exports = __webpack_public_path__ + "media/public/images/social/telegram-hover-d83bed62ac65511e39969ff18b7448aa.svg";